import React from 'react'
import USTemplateDefault from 'src/components/template/us'
// import { useDispatch } from 'react-redux'
// import { updateParams } from 'src/modules/reducers/params'
import styled from 'styled-components'
import { promoCodes } from 'src/constants/promoCodes'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import { usPlanData } from 'src/constants/planData/usPlanData'

export default (props) => {
  // const dispatch = useDispatch()

  // const params = {
  //   irad: '366904',
  //   irmp: '365718',
  // }

  // useEffect(() => {
  //   dispatch(updateParams(params))
  // }, [])
  const ctaCopy = useCtaText({ lang: 'en', market: 'us', disableFreeTrial: false })

  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        offerCode={promoCodes.optimum_pro_plan}
        offerBanner={{
          title: [
            'Optimum discount applied!',
            'Optimum customers get 30% off your first two months',
          ],
        }}
        title="Watch MSG Networks live"
        subtitle={
          <>
            See the Knicks, Rangers, Islanders, Devils,{' '}
            <div className="desktop-line-break"> Sabres & more. Regional restrictions apply.</div>
          </>
        }
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-optimum.png?ch=width&auto=format,compress"
        networkSubtitle={'Cancel online anytime.'}
        removeCable={true}
        networkSet="baseball"
        customNetworks={['msg', 'yesnetwork', 'fox', 'espn', 'fs1', 'nflnetwork', 'cbs', 'espn2']}
        showRSN={true}
        ctaText={ctaCopy}
        hasPlanCards={true}
        plans={[
          {
            ...usPlanData.pro_monthly,
            offerCode: promoCodes.optimum_pro_plan,

            promoImg: 'https://assets-imgx.fubo.tv/marketing/lp/images/card/us/fubo-pro-nfl.png',
            networkLogos: null,
            price: 84.99,
            discountedPrice: 59.49,
            savingsNote: '30% off',
            footnote:
              '*Reg. prices in effect after 2-mo promotional period ends. Additional taxes and fees may apply. Prices subject to change. Regional restrictions apply.',
            imageOverlay:
              'linear-gradient(193deg, rgba(0, 2, 21, 0.00) 16.24%, rgba(0, 2, 21, 0.70) 41.26%, #000215 67.2%)',
            banner: (
              <>
                Exclusive offer: <span>30% off for 2 months!</span>
              </>
            ),
            listItems: (data) => [
              { available: true, text: `${data.channels}+ channels` },
              {
                available: true,
                text: <span>Includes MLB and FanDuel Sports Network</span>,
              },
              { available: true, text: 'Unlimited Cloud DVR' },
              { available: true, text: 'Watch on up to 10 screens at once' },
              // { available: true, text: 'Free Trial' },
              { available: true, text: 'ESPN Unlimited included' },
            ],
          },
        ]}
        noIndex={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .offer-banner {
    .spectrum-offer-banner {
      display: flex;
      align-items: center;
      justify-content: center;
      .offer-banner-image {
        padding-right: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          width: 160px;
          @media (max-width: 767px) {
            width: 90px;
          }
        }
      }
      .offer-banner-text {
        padding-left: 16px;
        text-align: left;
        border-left: 1px solid #fff;
      }
    }
  }
`

// import React from 'react'
// import RedirectTemplate from 'src/components/template/redirect'
// export default props => <RedirectTemplate location={props.location} destination="/tv/" />
